module.exports = __webpack_public_path__ + "static/media/logospinner.a1edc962.gif";